import React, { useState, useEffect } from 'react';
import "./style.css"; // Import the CSS file
import confetti from 'canvas-confetti';

export default function ATSChecker() {
  const [file, setFile] = useState(null);
  const [jobDescription, setJobDescription] = useState("");
  const [feedback, setFeedback] = useState(null);
  const [atsScore, setAtsScore] = useState(null);
  

  useEffect(() => {
    if (atsScore !== null) {
      updateMeter(atsScore);
    }
  }, [atsScore]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("resume", file);
    formData.append("jobDescription", jobDescription);

    try {
      console.log("🚀 Sending API request to backend...");
      const response = await fetch("https://atsbackend-83j3.onrender.com/api/upload", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      console.log("🔹 Backend Response Data:", data);

      if (response.ok && data.feedback) {
        setFeedback(data.feedback);
        setAtsScore(data.atsScore || 0); // ✅ Ensure ATS score is not undefined
        console.log("✅ ATS Score Updated:", data.atsScore);
      } else {
        console.error("❌ Backend Error:", data.message);
        setFeedback({ error: "No valid AI feedback received." });
      }
    } catch (error) {
      console.error("❌ Upload error:", error);
      setFeedback({ error: "Failed to communicate with the server." });
    }
  };

  // Update the meter
  const updateMeter = (score) => {
    let inputScore = score;
    let progressPath = document.getElementById("progress");
    let scoreText = document.getElementById("score-value");
    let resultText = document.getElementById("result-text");
    let needle = document.getElementById("needle");

    let targetOffset = 283 - (inputScore / 100) * 283;
    let targetRotation = -90 + (inputScore / 100) * 180;

    let currentOffset = parseFloat(progressPath.style.strokeDashoffset) || 283;
    let currentScore = parseInt(scoreText.innerText) || 0;

    let step = (targetOffset - currentOffset) / 50;
    let scoreStep = (inputScore - currentScore) / 50;
    let count = 0;

    function animate() {
      if (count < 50) {
        currentOffset += step;
        currentScore += scoreStep;
        progressPath.style.strokeDashoffset = currentOffset;
        scoreText.innerText = Math.round(currentScore) + "%";
        count++;
        requestAnimationFrame(animate);
      } else {
        progressPath.style.strokeDashoffset = targetOffset;
        scoreText.innerText = inputScore + "%";
        updateResult(inputScore);
      }
    }
    animate();

    needle.style.transform = `translateX(-50%) rotate(${targetRotation}deg)`;
  };

  // Update the result text
  const updateResult = (score) => {
    let resultText = document.getElementById("result-text");
    if (score >= 0 && score < 40) {
      resultText.innerHTML = "Result: Poor 😢";
    } else if (score >= 40 && score < 60) {
      resultText.innerHTML = "Result: Good 🙂";
    } else if (score >= 60 && score < 80) {
      resultText.innerHTML = "Result: Excellent 😃";
    } else {
      resultText.innerHTML = "Result: Perfect 🤩";
      startCelebration();
    }
  };

  const startCelebration = () => {
    // Add confetti celebration (optional)
    confetti({
      particleCount: 200,
      spread: 90,
      origin: { y: 0.6 },
    });
  };

  return (
    <div className="body-ats">
      <div className="container">
        <h2 className="heading">ATS Resume Checker with Gemini AI</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="file"
            accept=".pdf,.docx"
            onChange={handleFileChange}
            className="input-file"
          />
          <textarea
            placeholder="Paste Job Description here..."
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
            className="input-textarea"
          />
          <button type="submit" className="button">
            Check Compatibility
          </button>
        </form>

        {atsScore !== null && (
          <div className="ats-score">
            <div className="main-container-ats-score">
              <div className="parent-container">

          
            <h3>ATS Score Meter</h3>
            <div className="meter-container">
              <svg className='ats-svg' viewBox="0 0 200 100">
                <defs>
                  <linearGradient id="multiColorGradient">
                    <stop offset="0%" stopColor="red" />
                    <stop offset="40%" stopColor="orange" />
                    <stop offset="60%" stopColor="yellow" />
                    <stop offset="100%" stopColor="green" />
                  </linearGradient>
                </defs>
                <path
                  d="M 10 100 A 90 90 0 0 1 190 100"
                  stroke="#ddd"
                  strokeWidth="15"
                  fill="none"
                />
                <path
                  id="progress"
                  d="M 10 100 A 90 90 0 0 1 190 100"
                  stroke="url(#multiColorGradient)"
                  strokeWidth="15"
                  fill="none"
                  strokeLinecap="round"
                  strokeDasharray="283"
                  strokeDashoffset="283"
                />
              </svg>
              <div className="needle" id="needle"></div>
              <div className="score-text">
                <span id="score-value">0%</span>
              </div>
            </div>
            <div className="result" id="result-text">
              Result: <span>😐</span>
            </div>
          </div>
                        </div>
                        </div>
        )}

        {feedback && !feedback.error && (
          <div className="feedback-section">
            <h3 className='feedback-heading'>AI Resume Feedback (Gemini)</h3>
            <p className='feedback-paragraph'>
              <strong>Missing Skills:</strong> {feedback.missingSkills?.join(", ") || " You have not a proper skill set "}
            </p>
            <p className='feedback-paragraph'>
              <strong>Strengths:</strong> {feedback.strengths?.join(", ") || " Nothing for show a Strengths"}
            </p>
            <p className='feedback-paragraph'>
              <strong>Areas for Improvement:</strong> {feedback.areasForImprovement?.join(", ") || "N/A"}
            </p>
            <p className='feedback-paragraph'>
              <strong>Summary:</strong> {feedback.feedbackSummary || "No summary available."}
            </p>
          </div>
        )}

        {feedback?.error && (
          <div className="error-section">
            <p className="error-text">⚠️ {feedback.error}</p>
          </div>
        )}
      </div>
    </div>
  );
}
